import moment from './moment'

/**
 * Generates an array of timeslots between a start and end time.
 *
 * @param {Object} param0 - The input parameters.
 * @param {string|Date} param0.start - The start time for generating timeslots.
 * @param {string|Date} param0.end - The end time for generating timeslots.
 * @param {number} param0.interval - The interval in minutes between each timeslot.
 * @returns {string[]} An array of ISO 8601 formatted timeslot strings.
 */

export default function generateTimeslots({
  start, // start time
  end, // end time
  interval, // in minutes
} = {}) {
  const startTime = moment(start)
  const endTime = moment(end)
  const timeslots = []

  while (startTime <= endTime) {
    timeslots.push(moment(startTime).format())
    startTime.add(interval, 'minutes')
  }
  return timeslots
}
